/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OpenBalancesTab {
  OPEN = 'open',
  CLOSED_WITH_NOTE = 'closed_with_note',
}
